import { useContext } from "react";
import { SmartMenuContext } from "@/config/context/smartMenuContext";
import { SmartSelectContact } from "../smart-select-contacts";

export const RelationsContactsCreate: React.FC<{
  t?: any;
  onClose?: () => void;
  refetch?: () => void;
  sectionType?: "permission" | "contact";
  contactId?: number;
  contactStores?: any;
  participants?: any;
  nextPosition?: any;
}> = ({
  t,
  onClose,
  refetch,
  sectionType,
  contactId,
  contactStores,
  participants,
  nextPosition,
}) => {
    const { smartMenuName, smartMenuLabel } = useContext(SmartMenuContext);

    const handleCancel = () => {
      onClose?.();
    };

    return (
      <SmartSelectContact
        handleCancel={handleCancel}
        onSaveContact={async (data: any) => {
          console.log("Contact saved");
        }}
        store={{
          code: contactStores?.storeCode,
          name: smartMenuLabel || smartMenuName,
          link: "store",
        }}
        refetch={refetch}
        sectionType={sectionType}
        contactId={contactId}
        contactStores={contactStores}
        participants={participants}
        nextPosition={nextPosition}
      />
    );
  };
